import React from 'react';
import styled from 'styled-components';
import { PODCAST_SAP_DESC, PODCAST_SAP_GEN } from 'Utils/Constants';
import {
  greyColor, loaderMergeGroup, primaryColor, primaryFont, primaryHeadingColor,
  SecondaryColor, secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { useDispatch } from 'react-redux';
import { actions } from 'Slice/CompaniesSlice';
import classNames from 'classnames';
import PodcastSAP from '../svgIcons/PodcastSAP';

const StyleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40%;
  .loading-merge {
    width: 160px;
    height: 160px;
    flex-shrink: 0;
  }
  .podcast-heading {
    a {
      color: ${primaryColor};
      text-decoration: underline;
    }
    display: inline-flex;
    color: ${primaryHeadingColor};
    text-align: center;
    font-family: ${secondaryFont};
    font-size: 32px;
    font-style: normal;
    font-weight: ${wMBold};
    line-height: 40px; 
    letter-spacing: -0.8px;
    margin-bottom: 8px;
    margin-top: 16px;
    &.secondary {
      margin-left: 5px;
      color: ${SecondaryColor};
      margin: 0px 0px 0 7px;
    }
    &.refresh{
      display: initial;
    }
  }
  .podcast-paragraph {
    a {
      color: ${primaryColor};
      text-decoration: underline;
    }
    color: ${greyColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-style: normal;
    font-weight: ${wMedium};
    line-height: 18px;
    letter-spacing: -0.562px;
    text-align: center;
    width: 333px;
    margin: 0;
  }
`;

type Props = {
  type?: 'creating' | 'refresh' | 'empty'
  onRefresh: () => void
} & typeof defaultProps;

const defaultProps = {
  type: 'empty',
};
const PodcastCreatingScreenNormalView = function PodcastCreatingScreenNormalView(props: Props) {
  const { type, onRefresh } = props;
  const dispatch = useDispatch();
  const onChooseClick = () => {
    dispatch(actions.setShowSAPHistory(true));
    dispatch(actions.setShowCreateNew(false));
    dispatch(actions.setShowPodcastTab(false));
  };

  return (
    <StyleWrapper>
      {type === 'creating' ? (
        <img className="loading-merge" src={loaderMergeGroup} alt="Loading..." />
      ) : (
        <PodcastSAP />
      )}
      <h2 className={classNames('podcast-heading', { refresh: type === 'refresh' })}>
        {type === 'creating' ? 'Generating your' : type === 'empty' ? 'Create your' : null}
        {
          type === 'refresh'
            ? (
              <>
                <a onClick={onRefresh}>Refresh</a>
                {' '}
                page to load
                <br />
                {' '}
                your Podcast
              </>
            )
            : null
        }
        {type !== 'refresh' ? (
          <h2 className="podcast-heading secondary">
            Podcast
          </h2>
        ) : null}
      </h2>
      <p className="podcast-paragraph">
        {type === 'empty' ? (
          <>
            <a onClick={onChooseClick}>Choose</a>
            {' '}
            {PODCAST_SAP_DESC}
          </>
        ) : type === 'creating' ? PODCAST_SAP_GEN : null}
      </p>
    </StyleWrapper>
  );
};
PodcastCreatingScreenNormalView.defaultProps = defaultProps;
export default PodcastCreatingScreenNormalView;
